import {Modal} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import {ClipLoader} from 'react-spinners';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faChevronRight} from '@fortawesome/free-solid-svg-icons';
import MyLoader from "./MyLoader";
import useAuthz from "../../hooks/useAuthz";

const css = {
  modalHeader: {
    overflow: 'auto',
    overflowX: 'hidden',
    width: '325px'
  }
};

const MyModal = (props) => {
  const navigate = useNavigate();
  const {fullscreen, title, additionalTitle, urlCloseModal, loading, overlayLoading, entries, additionalEntry, content, refs, entryPoint, entryPointReadUntil, validSteps, data} = props;
  const [numActiveEntry, setNumActiveEntry] = useState(0);
  const [authz, user, profil] = useAuthz();

  useEffect(() => {
    if (entryPoint) setNumActiveEntry(entryPoint);
    else setNumActiveEntry(0);
  }, []);
  useEffect(() => {
    switchActiveStep(numActiveEntry);
  }, [numActiveEntry]);
  useEffect(() => {
    switchActiveStep(entryPointReadUntil);
    changeActiveEntry(entryPointReadUntil);
  }, [entryPointReadUntil]);

  const handleClose = (reason) => {
    if (reason !== 'backdropClick') {
      navigate(urlCloseModal);
    }
  };
  const switchActiveStep = (numActiveEntry) => {
    if (numActiveEntry !== null && entries.length > 0) {
      entries.forEach((aEntry, i) => {
        if (refs.current['step-' + aEntry.name] && refs.current['step-' + aEntry.name].style) {
          refs.current['step-' + aEntry.name].style.display = (i !== numActiveEntry ? 'none' : 'block');
        }
      });
    }
  };
  const changeActiveEntry = (numActiveEntry) => {
    setNumActiveEntry(numActiveEntry);
  };

  return (
    <>
      <Modal open={true} onClose={(event, reason) => handleClose(reason)} style={{display: 'flex'}} disableEscapeKeyDown={true}>
        <div className='modal'>
          <MyLoader loading={overlayLoading}/>
          {loading && (<div className={`modal-content ${fullscreen === true ? 'modal-fullscreen-content ' : ''} flex-center-column`}>
            <ClipLoader color='#0094ca' loading={loading} size={75}/>
            <p>Merci de patienter...</p>
          </div>)}
          {!loading && (<div className={`modal-content ${fullscreen === true ? 'modal-fullscreen-content ' : ''} mode-menu`}>
            <div className='modal-header' style={css.modalHeader}>
              <div className='modal-title-container'>
                <span className='modal-title'>{title.toUpperCase()}</span>
                <span className='modal-title'>{additionalTitle.toUpperCase()}</span>
              </div>
              <div className='modal-menu'>
                {entries.map((entry, i) => {
                  return (
                    <div className={`modal-menu-entry ${numActiveEntry === i ? 'selected-entry' : ''}`}
                         key={i} onClick={() => changeActiveEntry(i)}>
                      {numActiveEntry === i && <div className='selected-bar-color'/>}

                      {validSteps["step" + (i + 1)] &&
                        <div className='buttons-request-table' style={{backgroundColor: '#9dbf42', marginLeft: '20px', width: '15px', height: '15px'}}>
                          <FontAwesomeIcon icon={faCheck} style={{color: '#ffffff', height: '9px'}}/>
                        </div>
                      }
                      {!validSteps["step" + (i + 1)] &&
                        <div className='buttons-request-table' style={{marginLeft: '20px', width: '15px', height: '15px'}}/>
                      }
                      <div className={`modal-menu-entry-libelle`}>{entry.description}</div>
                      <FontAwesomeIcon className={`icon-chevron-left`} icon={faChevronRight} color={numActiveEntry === i ? "#0094ca" : "#323c46"}/>
                    </div>
                  );
                })}
                {additionalEntry}
              </div>
            </div>
            <div className='modal-step'>{content}</div>
          </div>)}
        </div>
      </Modal>
    </>
  );
};

export default MyModal;
